var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 19.5,
    rx: 1.75,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.941 9.99999C17.941 13.0862 15.4678 15.5881 12.417 15.5881C9.36619 15.5881 6.89301 13.0862 6.89301 9.99999C6.89301 6.91375 9.36619 4.41186 12.417 4.41186C15.4678 4.41186 17.941 6.91375 17.941 9.99999Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.107 9.99999C25.107 13.0862 22.6338 15.5881 19.583 15.5881C16.5322 15.5881 14.059 13.0862 14.059 9.99999C14.059 6.91375 16.5322 4.41186 19.583 4.41186C22.6338 4.41186 25.107 6.91375 25.107 9.99999Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 14.2554C17.1878 13.2305 17.941 11.7053 17.941 10.0021C17.941 8.29893 17.1878 6.77373 16 5.74877C14.8122 6.77373 14.059 8.29893 14.059 10.0021C14.059 11.7053 14.8122 13.2305 16 14.2554Z",
    fill: "#6C6BBD",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic3.c725544ad99c9c7b59293eefa4a20d2e.svg";
export { ForwardRef as ReactComponent };